import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Routes } from "react-router-dom";

import { ROUTES } from "../data/content";
import ScrollToTop from "./general/ScrollToTop";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./home/Home";
import BookARoom from "./book/BookARoom";
import ContactSection from "./contact/ContactSection";
import NotFound from "./general/NotFound";

const App = () => {
  return (
    <React.Fragment>
      <a
        className={"skip-link"}
        href={"#main"}
        onClick={(e) => {
          e.preventDefault();
          document.getElementById("main").focus();
        }}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Header />
      <main
        id={"main"}
        className={"site-main"}
        tabIndex={-1}
      >
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={<Home />}
          />
          <Route
            path={ROUTES.BOOK}
            element={<BookARoom />}
          />
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
        {/* Contact Us is at the bottom of every page, as on Wix */}
        <ContactSection />
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default App;
